import { FlagEmoji } from '@/components/atoms/FlagEmoji/FlagEmoji';
import { cn } from '@/lib/utils';
import { languageAndFlagByCountryCode } from '@/shared/languageCodes';
import { emojiFlagToCountryCode } from '@/util/emojiFlagToCountryCode';

type QuickLanguageOptionProps = {
  language: string;
  handleClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isActive?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const QuickLanguageOption = ({
  language,
  handleClick,
  isActive = false,
  ...rest
}: QuickLanguageOptionProps) => {
  const capitalizedShortLanguageCode = language.split('-')[0].toUpperCase();
  const countryCode = emojiFlagToCountryCode(languageAndFlagByCountryCode[language]?.flag);

  return (
    <button
      className={cn(
        'text-sm leading-5 font-medium',
        'flex items-center gap-2 rounded-md border border-border bg-background px-4 py-1',
        'hover:bg-accent hover:text-accent-foreground',
        isActive && 'bg-selected text-selected-foreground',
        '[&_img]:max-w-4'
      )}
      type="button"
      onClick={handleClick}
      {...rest}
    >
      {countryCode && <FlagEmoji countryCode={countryCode} />}
      {capitalizedShortLanguageCode}
    </button>
  );
};
